<template>
  <div class="panel center-top">
    <div class="panel-title pv-panel-title-row">
      ⚡ 今日全市能耗总览
      <a href="#" class="pv-export-link" @click.prevent="onExport">📥 导出</a>
    </div>
    <div class="energy-cards">
      <div class="energy-item">
        <div class="ei">☀️</div>
        <div class="ed">
          <div class="ev">{{ pvText }}</div>
          <div class="el">今日光伏发电 (kWh)</div>
        </div>
      </div>
      <div class="energy-item">
        <div class="ei">🔌</div>
        <div class="ed">
          <div class="ev">{{ gridText }}</div>
          <div class="el">今日市电用量 (kWh)</div>
        </div>
      </div>
      <div class="energy-item">
        <div class="ei">⚡</div>
        <div class="ed">
          <div class="ev">{{ totalText }}</div>
          <div class="el">总用电量 (kWh)</div>
        </div>
      </div>
      <div class="energy-item">
        <div class="ei">🏆</div>
        <div class="ed">
          <div class="ev">{{ rateText }}</div>
          <div class="el">能源自给率</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {
  getTodayEnergy,
  exportTodayEnergyFile,
} from "@/network/photovoltaic";
import { downloadBlobFile } from "@/constant/export-file";

function fmtKwh(n) {
  if (n == null || n === "") return "—";
  const x = Number(n);
  if (Number.isNaN(x)) return "—";
  return x.toLocaleString("zh-CN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

function displaySelfRate(d) {
  if (!d) return "—";
  if (d.selfRateStr != null && String(d.selfRateStr).trim() !== "") {
    const s = String(d.selfRateStr).trim();
    return s.endsWith("%") ? s : s + "%";
  }
  const r = d.selfRate;
  if (r == null || Number.isNaN(Number(r))) return "—";
  const p = Number(r) <= 1 && Number(r) >= 0 ? Number(r) * 100 : Number(r);
  return (Math.round(p * 10) / 10).toFixed(1) + "%";
}

/** xlsx(zip) / 老版 xls 头判断 */
function isBinarySheet(buf) {
  if (!(buf instanceof ArrayBuffer) || buf.byteLength < 4) return false;
  const u8 = new Uint8Array(buf);
  if (u8[0] === 0x50 && u8[1] === 0x4b) return true;
  if (u8[0] === 0xd0 && u8[1] === 0xcf && u8[2] === 0x11 && u8[3] === 0xe0)
    return true;
  return false;
}

export default {
  name: "PvTodayEnergyOverview",
  data() {
    return {
      today: null,
      pollTimer: null,
    };
  },
  computed: {
    pvText() {
      return fmtKwh(this.today && this.today.generation);
    },
    gridText() {
      return fmtKwh(this.today && this.today.consumption);
    },
    totalText() {
      return fmtKwh(this.today && this.today.total);
    },
    rateText() {
      return displaySelfRate(this.today);
    },
  },
  mounted() {
    this.fetchToday();
    this.pollTimer = setInterval(() => this.fetchToday(), 60000);
  },
  beforeDestroy() {
    if (this.pollTimer) clearInterval(this.pollTimer);
  },
  methods: {
    fetchToday() {
      getTodayEnergy()
        .then((res) => {
          if (!res || res.code !== 0) return;
          this.today = res.data || null;
        })
        .catch(() => {});
    },
    csvFromPayload(d) {
      const row = [
        "今日光伏发电(kWh)",
        "今日市电用量(kWh)",
        "总用电量(kWh)",
        "能源自给率",
      ].join(",");
      const val = [
        d && d.generation != null ? d.generation : "",
        d && d.consumption != null ? d.consumption : "",
        d && d.total != null ? d.total : "",
        displaySelfRate(d),
      ].join(",");
      return `\uFEFF${row}\n${val}`;
    },
    fallbackCsvExport() {
      const blob = new Blob([this.csvFromPayload(this.today)], {
        type: "text/csv;charset=utf-8",
      });
      const name =
        `今日全市能耗_${moment().format("YYYYMMDD_HHmm")}.csv`;
      const elink = document.createElement("a");
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      elink.download = name;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    onExport() {
      exportTodayEnergyFile()
        .then((buf) => {
          if (buf instanceof ArrayBuffer && buf.byteLength > 0) {
            if (isBinarySheet(buf)) {
              downloadBlobFile(
                buf,
                `今日全市能耗_${moment().format("YYYYMMDD")}`
              );
              return;
            }
            try {
              const text = new TextDecoder("utf-8").decode(buf);
              const j = JSON.parse(text);
              if (j.code === 0 && j.data) {
                const blob = new Blob([`\uFEFF${this.csvFromPayload(j.data)}`], {
                  type: "text/csv;charset=utf-8",
                });
                const elink = document.createElement("a");
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                elink.download = `今日全市能耗_${moment().format("YYYYMMDD_HHmm")}.csv`;
                document.body.appendChild(elink);
                elink.click();
                document.body.removeChild(elink);
                return;
              }
            } catch (_) {
              /* fallback */
            }
          }
          this.fallbackCsvExport();
        })
        .catch(() => this.fallbackCsvExport());
    },
  },
};
</script>
